/**
 * defa.models.InvitationSubscription
 * The DEFA InvitationSubscription Model.
 * @version 1.0.0
 * @author Benjamin Rusten
 */
import { defa } from 'defa-object';
import Model from 'scripts/poppet/model';
const apiHost = defa.vars.apiHost;
	
const api = {
	invitationSubscription   : apiHost + '/invitations',
};
	
const InvitationSubscription = Model.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
		
	defaults: {
		unit: {},
		subscriptionNumber: ''
	},
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
		/**
		 * Separates objects and stores information in the channel.
		 * @overwrite
		 *
		 * @param  {Object} response  The server response, which can be a bundle of linked objects.
		 * @return {Object}           The parsed response, now only containing the correct variables for an Invitation.
		 */
	parse: function( response ) {
		return response;
	},
		
		/**
		 * Accepts the invitation.
		 */
	_accept: function (options) {
		let self = this;
		$.ajax({
				 type: 'POST',
				 url: apiHost + '/invitations/' + options.invitationId + '/subscriptions/' + self.get('id') + '/accept',
				 contentType: 'application/json',
				 data: JSON.stringify({token: options.token}),
			 })
			 .done(function (response) {
				 options.success(response);
				 self.trigger('destroy',self)
			 })
			 .fail(function (error) {
				 options.error(error.responseJSON.message);
			 });
	},
		
		/**
		 * Rejects the invitation.
		 */
	_reject: function (options) {
		let self = this;
		$.ajax({
				 type: 'POST',
				 url: apiHost + '/invitations/' + options.invitationId + '/subscriptions/' + self.get('id') + '/reject',
				 contentType: 'application/json',
				 data: JSON.stringify({token: options.token}),
			 })
			 .done(function (response) {
				 options.success(response);
				 self.trigger('destroy',self)
			 })
			 .fail(function (error) {
				 options.error(error.responseJSON.message);
			 });
	}
});

export default InvitationSubscription;
